import React from "react";
import { Formik, FormikHelpers, Form } from "formik";
import FormikTextField from "../../Input/TextField/TextField";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import { useStore } from "../../../store/useStore";
import Fieldset from "../../Input/Fieldset/Fieldset";
import { Button } from "antd";
import NoSidebarLayout from "../../Layout/NoSidebarLayout";
import * as Yup from "yup";
import {
  fetchILivestockUser,
  forceSessionRefresh,
} from "../../../store/actions";
import { defaultIlivestockQuery } from "../../../util";

type FormData = {
  newPassword: string;
  confirmPassword: string;
};

type Props = {};

const Schema = Yup.object().shape<FormData>({
  newPassword: Yup.string().required("Required"),
  confirmPassword: Yup.string().when("newPassword", {
    is: (value: string) => value && value.length,
    then: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Passwords do not match")
      .required("Please confirm your new password"),
  }),
});

const NewPasswordForm: React.FC<Props> = () => {
  const history = useHistory();
  const { state, dispatch } = useStore();
  const initialValues: FormData = {
    confirmPassword: "",
    newPassword: "",
  };
  const handleSubmit = async (
    values: FormData,
    helpers: FormikHelpers<FormData>
  ) => {
    try {
      // TODO Refactor and error catch
      await Auth.completeNewPassword(state.user, values.newPassword, {});
      await dispatch(forceSessionRefresh());
      await dispatch(fetchILivestockUser(defaultIlivestockQuery));
      history.push("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <NoSidebarLayout>
      <div className="flex h-full items-center">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={Schema}
        >
          {({ values, handleSubmit }) => {
            return (
              <Form className="flex flex-col w-full">
                <Fieldset>
                  <FormikTextField
                    type="password"
                    name="newPassword"
                    label="Please choose a new password"
                    required
                  />
                  <FormikTextField
                    type="password"
                    name="confirmPassword"
                    label="Please confirm your new password"
                    required
                    disabled={!values.newPassword.length}
                  />
                  <div className="flex flex-col text-center">
                    <Button
                      type="primary"
                      onClick={() => {
                        handleSubmit();
                      }}
                      className="login-form-button"
                    >
                      Update your password
                    </Button>
                  </div>
                </Fieldset>
              </Form>
            );
          }}
        </Formik>
      </div>
    </NoSidebarLayout>
  );
};

export default NewPasswordForm;
